<template>
  <nav class="content-menu">
    <a href="#" data-reveal-id="maSelector" class="button dropdown hide-for-medium-up" aria-hidden="true" inert="">
      Mijn overzicht
    </a>
    <div id="maSelector" class="reveal-modal hide-for-medium-up" data-reveal="" aria-labelledby="modalTitle"
         aria-hidden="true" role="dialog" inert="">
      <div class="modal-content">
        <span class="nav-header">Mijn Arriva Zakelijk</span>
        <div class="linklist">
          <ul>
            <navigation-item
              v-for="item in items"
              :key="item.routeName"
              :route-name="item.routeName"
              :route-label="item.routeLabel"
              :tab-tndex="-1"
              :children="item.children"
            />
          </ul>
        </div>
        <button class="close-reveal-modal" data-close="" aria-label="Sluiten" type="button" tabindex="-1">
          <span aria-hidden="true"></span>
        </button>
      </div>
    </div>
    <div class="reveal-modal show-for-medium-up">
      <div class="modal-content">
        <span class="nav-header">Mijn Arriva Zakelijk</span>
        <div class="linklist">
          <ul>
            <navigation-item
              v-for="item in items"
              :key="item.routeName"
              :route-name="item.routeName"
              :route-label="item.routeLabel"
              :children="item.children"
            />
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import NavigationItem from '../components/NavigationItem'

export default {
  name: 'Navigation',
  components: {
    NavigationItem
  },
  data () {
    return {
      items: [
        {
          routeName: 'welcome',
          routeLabel: 'Welkomstpagina'
        },
        {
          routeName: 'company',
          routeLabel: 'Bedrijfsgegevens'
        },
        {
          routeName: 'card',
          routeLabel: 'Mijn passen'
        },
        ...this.getOptionalMenuItems(),
        {
          routeName: 'invoice',
          routeLabel: 'Facturen'
        },
        {
          routeName: 'invoice-specification',
          routeLabel: 'Specificaties'
        },
        {
          routeName: 'contact',
          routeLabel: 'Service & Contact'
        },
        {
          routeName: 'logout',
          routeLabel: 'Uitloggen',
          customClass: 'logout'
        }
      ]
    }
  },
  methods: {
    getOptionalMenuItems () {
      const selfServiceMenuItems = [
        {
          routeName: 'order',
          routeLabel: 'Bestellingen',
          children: [
            {
              routeName: 'order-replacement-card',
              routeLabel: 'Kaart vervangen'
            },
            {
              routeName: 'order-terminate-card',
              routeLabel: 'Kaart beëindigen'
            }
          ]
        }
      ]

      return this.$store.state.company.selfServiceStatus.selfServiceEnabled ? selfServiceMenuItems : []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue